import { NumberValue, VALUE_TYPE } from "Components/NumberValue";

import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { AccidentProduct } from "Store/interfaces/products/checkout/riskProducts/AccidentProduct";
import React from "react";
import { ProductDetail } from "../../interface";

export const accidentDetailsList = (
  product: AccidentProduct,
  urls: Record<string, string>,
): ProductDetail[] => {
  const { applicableTermsAccident } = urls;

  return [
    {
      name: "deathCoverageText",
      value: (
        <NumberValue
          type={VALUE_TYPE.NOK}
          value={product.deathCoverageAmount}
        />
      ),
    },
    {
      name: "disabilityCoverageText",
      value: (
        <NumberValue
          type={VALUE_TYPE.NOK}
          value={product.disabilityCoverageAmount}
        />
      ),
    },
    {
      name: "deductible",
      value: (
        <a href={applicableTermsAccident} target="_blank" rel="noreferrer">
          {<DeductibleValue value={"??"} />}
        </a>
      ),
    },
  ];
};
